module.exports = __webpack_public_path__ + "static/media/cadebyDepot.7132d2e9.jpg";